import { reciboApi } from '@/api'
import { IResponseElement, ReciboFiltroModel, ReciboInterface } from '@/models'

const useReciboEndpoint = () => {
  const find = async (context: ReciboFiltroModel) => {
    try {
      const { data } = await reciboApi.post<IResponseElement<ReciboInterface>>(`find`, context)

      return { ok: true, response: data }
    } catch (error: any) {
      return { ok: false, message: error }
    }
  }

  return {
    find,
  }
}

export default useReciboEndpoint
